import { Typography } from 'fronton-react';
import React, { PropsWithChildren } from 'react';
import { jc } from 'utils';
import { AvatarWithFallback, AvatarWithFallbackProps } from '../fronton-decorators/avatar-with-fallback';
import { ReviewContentFormatter } from '../review-content-formatter';
import { authorBlock, authorContainer, dateClass, personTitle } from './review.styles';
import { getDate } from './util/get-date';

export type ReviewAuthorContentProps = {
  authorName: string;
  authorInitials: string;
  locale: string;
  authorAvatarUrl?: string | null;
  avatarThemeColor?: AvatarWithFallbackProps['color'];
  date?: Date;
} & React.HTMLAttributes<HTMLElement>;

export const ReviewAuthorContent: React.FC<ReviewAuthorContentProps> = ({
  authorName,
  authorInitials,
  locale,
  authorAvatarUrl,
  avatarThemeColor,
  date,
  className = '',
  ...htmlProps
}) => {
  return (
    <div className={jc(className, authorContainer)} {...htmlProps}>
      <AvatarWithFallback
        data-qa="review-avatar-fallback"
        imageSrc={authorAvatarUrl}
        name={authorInitials}
        color={avatarThemeColor}
      />

      <div className={authorBlock}>
        <ReviewContentFormatter
          components={{
            p: ({ children }) => <PersonTitle>{children}</PersonTitle>,
            a: ({ children }) => <span>{children}</span>,
            link: ({ children }) => <span>{children}</span>,
          }}
        >
          {authorName}
        </ReviewContentFormatter>

        {date && (
          <Typography data-qa="review-date" className={dateClass} variant="caption" color="text-minor">
            {getDate(date, locale)}
          </Typography>
        )}
      </div>
    </div>
  );
};

const PersonTitle: React.FC<PropsWithChildren> = ({ children }) => (
  <Typography variant="s" size="subtitle" color="text-primary" className={personTitle}>
    {children}
  </Typography>
);
